export var DCEventTypeEnum;
(function (DCEventTypeEnum) {
    DCEventTypeEnum["started"] = "DCStartedEvent";
    DCEventTypeEnum["messageReceived"] = "DCMessageReceivedEvent";
    DCEventTypeEnum["ending"] = "DCEndingEvent";
    DCEventTypeEnum["ended"] = "DCEndedEvent";
    DCEventTypeEnum["roomCreated"] = "DCRoomCreatedEvent";
    DCEventTypeEnum["cobrowseRequested"] = "DCCobrowseRequestedEvent";
})(DCEventTypeEnum || (DCEventTypeEnum = {}));
